import { CncReport } from '@gameonly/core';
import { Checkbox, List, ListItem, ListItemIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ValidateReport from './ValidateReport';

interface ChecklistProps {
  report: CncReport;
  isValidated: boolean;
}

const ReadOnlyChecklist = ({ report, isValidated }: ChecklistProps) => {
  const { t } = useTranslation(['cnc-reports', 'common']);
  const checklistItems = [
    {
      label: t('cnc-reports:dashboard.checklist.local-added'),
      checked: report.locals.length > 0,
    },
    {
      label: t('cnc-reports:dashboard.checklist.local-validated'),
      checked: report.locals.every((local) => local.validated),
    },
    {
      label: t('cnc-reports:dashboard.checklist.information-filled'),
      checked: report.isInformationComplete,
    },
    {
      label: t('cnc-reports:dashboard.checklist.report-validated'),
      checked: Boolean(report.validatedAt),
    },
  ];

  return (
    <List style={{ padding: 0 }}>
      {checklistItems.map((item, index) => (
        <ListItem key={index} disableGutters style={{ padding: '4px 0' }}>
          <ListItemIcon style={{ minWidth: 'auto', marginRight: '8px' }}>
            <Checkbox
              edge="start"
              checked={item.checked}
              disableRipple
              sx={{
                padding: 0,
                paddingLeft: '9px',
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }}
            />
          </ListItemIcon>
          <p className="hxr">{item.label}</p>
        </ListItem>
      ))}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '16px',
        }}
      >
        {!isValidated && <ValidateReport report={report} />}
      </div>
    </List>
  );
};

export default ReadOnlyChecklist;
